const msalIdTokenKey = `msal.${process.env.VUE_APP_AUTHENTICATION_CLIENT_ID}.idtoken`;
const piriMsalIdTokenKey = `piri.msal.${process.env.VUE_APP_AUTHENTICATION_CLIENT_ID}.idtoken`;
const scopes = ['User.Read', 'User.Read.All', 'profile', 'openid', 'email'];

export {
  msalIdTokenKey,
  piriMsalIdTokenKey,
  scopes,
};
